module.exports = __webpack_public_path__ + "img/friend.5132449e.png";